(function () {
  "use strict";

  const awtomicWindow = /** @type {Window & { Awtomic?: any }} */ (window);

  // Feature flags -----------------------------------------------------------
  // When true, editing (cp-edit-hidden) is gated by the release/customization
  // window as before. When false, the customization-window checks are skipped
  // entirely, so editing is no longer blocked by being outside the window
  // (other gates like recently-billed still apply).
  const useCustomizationWindow = false;
  // When true, a PICKUP subscription is treated as non-editable.
  const disablePickupEdit = true;

  // Detect a PICKUP subscription from its DeliveryMethod. Shipping subs have
  // __typename "SubscriptionDeliveryMethodShipping" (with shippingOptions);
  // pickup subs use a "...Pickup" typename (with a pickupOption).
  /** @param {any} subscription */
  const isPickupSubscription = (subscription) => {
    const dm = subscription && subscription.DeliveryMethod;
    if (!dm) return false;
    return /pickup/i.test(String(dm.__typename || "")) || !!dm.pickupOption;
  };

  /** @param {string | number} productId */
  const getReleaseWindowFromProductId = (productId) => {
    const productIdString = String(productId);
    for (const [bundleId, data] of releaseWindowEntries) {
      if (productIdString.includes(bundleId)) {
        return data;
      }
    }
    return null;
  };

  // CX-4775 — products that exempt a subscription from the cp-edit release-window block.
  // If any line's ProductId matches one of these, the sub bypasses ALL cp-edit-block rules
  // (release window + recently-billed). Substring-matched, same as getReleaseWindowFromProductId.
  const editBlockExceptionBundleIds = [
    "10543715877166", // Wild Test Club
    "10568341291310" // Wild Test Club 2
  ];
  /** @param {string | number} productId */
  const isEditBlockExceptionProductId = (productId) => {
    const s = String(productId);
    return editBlockExceptionBundleIds.some((id) => s.includes(String(id)));
  };

  /** @type {Record<string, { brand: string, bundleName: string, Shipping: { date: { customizationStarts: string, customizationEnds: string, billingDate: string, shippingDate: string } }, Pickup: { date: { customizationStarts: string, customizationEnds: string, billingDate: string, shippingDate: string } } }>} */
  const releaseWindowData = {
    10541219676462: {
      brand: "HALL",
      bundleName: "Primary Colors",
      Shipping: {
        date: {
          customizationStarts: "07-20",
          customizationEnds: "08-14",
          billingDate: "08-17",
          shippingDate: "08-26"
        }
      },
      Pickup: {
        date: {
          customizationStarts: "07-21",
          customizationEnds: "08-23",
          billingDate: "08-25",
          shippingDate: "09-02"
        }
      }
    },
    10511307702574: {
      brand: "HALL",
      bundleName: "Collection",
      Shipping: {
        date: {
          customizationStarts: "07-22",
          customizationEnds: "08-17",
          billingDate: "08-19",
          shippingDate: "08-31"
        }
      },
      Pickup: {
        date: {
          customizationStarts: "07-21",
          customizationEnds: "08-23",
          billingDate: "08-25",
          shippingDate: "09-02"
        }
      }
    },
    10542471774510: {
      brand: "WALT",
      bundleName: "Vintner's",
      Shipping: {
        date: {
          customizationStarts: "07-27",
          customizationEnds: "08-21",
          billingDate: "08-24",
          shippingDate: "09-02"
        }
      },
      Pickup: {
        date: {
          customizationStarts: "07-21",
          customizationEnds: "08-23",
          billingDate: "08-25",
          shippingDate: "09-02"
        }
      }
    },
    10542568210734: {
      brand: "WALT",
      bundleName: "Appellation",
      Shipping: {
        date: {
          customizationStarts: "07-27",
          customizationEnds: "08-21",
          billingDate: "08-24",
          shippingDate: "09-02"
        }
      },
      Pickup: {
        date: {
          customizationStarts: "07-21",
          customizationEnds: "08-23",
          billingDate: "08-25",
          shippingDate: "09-02"
        }
      }
    },
    10542553497902: {
      brand: "BACA",
      bundleName: "BACA",
      Shipping: {
        date: {
          customizationStarts: "07-27",
          customizationEnds: "08-21",
          billingDate: "08-24",
          shippingDate: "09-02"
        }
      },
      Pickup: {
        date: {
          customizationStarts: "07-21",
          customizationEnds: "08-23",
          billingDate: "08-25",
          shippingDate: "09-02"
        }
      }
    },
    10543703589166: {
      brand: "Michel Foch",
      bundleName: "Michel Foch",
      Shipping: {
        date: {
          customizationStarts: "07-27",
          customizationEnds: "08-21",
          billingDate: "08-24",
          shippingDate: "09-02"
        }
      },
      Pickup: {
        date: {
          customizationStarts: "07-21",
          customizationEnds: "08-23",
          billingDate: "08-25",
          shippingDate: "09-02"
        }
      }
    },
    10542545797422: {
      brand: "Mixed (Duals/Hybrid)",
      bundleName: "Custom",
      Shipping: {
        date: {
          customizationStarts: "07-20",
          customizationEnds: "08-23",
          billingDate: "08-24",
          shippingDate: "09-02"
        }
      },
      Pickup: {
        date: {
          customizationStarts: "07-21",
          customizationEnds: "08-23",
          billingDate: "08-25",
          shippingDate: "09-02"
        }
      }
    }
  };

  const releaseWindowEntries = Object.entries(releaseWindowData);

  /** @param {string} monthDay @param {number} year */
  const parseMonthDayStart = (monthDay, year) => {
    const parts = String(monthDay).split("-");
    const month = Number(parts[0]);
    const day = Number(parts[1]);
    if (!Number.isFinite(month) || !Number.isFinite(day)) return new Date(NaN);
    return new Date(year, month - 1, day, 0, 0, 0, 0);
  };

  /** @param {string} monthDay @param {number} year */
  const parseMonthDayEnd = (monthDay, year) => {
    const parts = String(monthDay).split("-");
    const month = Number(parts[0]);
    const day = Number(parts[1]);
    if (!Number.isFinite(month) || !Number.isFinite(day)) return new Date(NaN);
    return new Date(year, month - 1, day, 23, 59, 59, 999);
  };

  /** @param {string} selector @param {(elements: NodeListOf<Element>) => void} callback @param {number} [delay=1] @param {number} [failsafeDelay] */
  const waitForElement = (selector, callback, delay = 1, failsafeDelay) => {
    const run = () => {
      const elements = document.querySelectorAll(selector);
      if (!elements.length) return false;
      if (typeof callback === "function") {
        setTimeout(() => callback(document.querySelectorAll(selector)), delay);
      }
      return true;
    };

    if (run()) return;

    const observeRoot = document.body || document.documentElement;
    const observer = new MutationObserver((_mutations, obs) => {
      if (run()) obs.disconnect();
    });

    observer.observe(observeRoot, {
      childList: true,
      subtree: true
    });

    if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
  };

  //awt cp
  let cpLoaded = false;
  if (window.location.search.includes("subscriptionId=")) {
    document.body && document.body.classList.add("awt-cp", "cp-edit-hidden");

    // Debugger hook — fires when the line-edit button is clicked. Real
    // functionality TBD.
    document.addEventListener(
      "click",
      (event) => {
        const target = /** @type {Element} */ (event.target);
        const editBtn = target && target.closest && target.closest("button.awtomatic-line-edit-button");
        if (editBtn) {
          // Click the first action ("link") of a list. Use a full
          // mousedown -> mouseup -> click sequence: a bare .click() can be
          // ignored (e.g. Chakra records the mousedown target and only acts if
          // mouseup/click lands on that same element).
          /** @param {Element} el */
          const simulateClick = (el) => {
            ["mousedown", "mouseup", "click"].forEach((type) => {
              el.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
            });
          };
          // The first action is either the first <a> in a desktop inline action
          // list, or the first button/link inside the first <li> of the mobile
          // bottom-sheet modal (e.g. "Change selection").
          /** @param {Element | null} root */
          const clickFirstAction = (root) => {
            if (!root) return;
            const first = root.querySelector(".bundle-action-list a") || root.querySelector("li:first-child a, li:first-child button");
            if (first) simulateClick(first);
          };

          // Case 1 — desktop inline action list next to the edit button.
          clickFirstAction(editBtn.closest(".bundle-action-list-container"));

          // Case 2 — mobile bottom-sheet modal opens asynchronously; wait for it,
          // then click its first action.
          waitForElement(
            ".subscription-overlay-open .chakra-modal__content-container",
            () => {
              clickFirstAction(document.querySelector(".subscription-overlay-open .chakra-modal__content-container"));
            },
            100,
            10000
          );
        }
      },
      true
    );

    window.addEventListener("awtomic-cp-loaded", () => {
      if (cpLoaded) return; // fire once per detail-view load
      cpLoaded = true;

      //check sub lines and add brand classes to body for cp
      try {
        const subscriptionDetails = awtomicWindow.Awtomic?.subscriptionDetails;
        const lines = subscriptionDetails?.Lines;
        if (!lines || !document.body) return;

        // PICKUP subscriptions are non-editable when disablePickupEdit is on.
        const pickupBlocked = disablePickupEdit && isPickupSubscription(subscriptionDetails);

        // check releaseWindowData for matched bundle id and only remove cp-edit-hidden when every matched line is inside its window

        let matchedReleaseWindowLineCount = 0;
        let matchedReleaseWindowLineCountInsideWindow = 0;
        // keep editing blocked if any matched line was billed
        // within the last 30 days.
        let recentlyBilled = false;
        // CX-4775 — set true if any line is an "ignore"/exception product
        let hasEditBlockException = false;

        for (let i = 0; i < lines.length; i++) {
          const productId = lines[i] && lines[i].ProductId;
          if (!productId) continue;

          // CX-4775 — exception products bypass the cp-edit block entirely
          if (isEditBlockExceptionProductId(productId)) hasEditBlockException = true;

          // customization-window gating (skipped when useCustomizationWindow is false)
          if (useCustomizationWindow) {
            const data = getReleaseWindowFromProductId(productId);
            if (data) {
              matchedReleaseWindowLineCount += 1;
              const now = new Date();
              const currentYear = now.getFullYear();
              const customizationStarts = parseMonthDayStart(data.Shipping.date.customizationStarts, currentYear);
              const customizationEnds = parseMonthDayEnd(data.Shipping.date.customizationEnds, currentYear);

              if (customizationEnds < customizationStarts) {
                customizationEnds.setFullYear(customizationEnds.getFullYear() + 1);
              }

              if (now >= customizationStarts && now <= customizationEnds) {
                matchedReleaseWindowLineCountInsideWindow += 1;
              }
            }
          }
        }

        // CX-4727 item 3 — re-block editing if the subscription was ACTUALLY
        // billed within the last 30 days. The previous approach derived the
        // billing date from the release-window MM-DD field, which never fires
        // for subs whose products aren't registered in releaseWindowData (e.g.
        // sub 34231648558). Use the real billing history instead: any
        // SUCCESS billing attempt completed within the last 30 days blocks.
        const billingAttempts = awtomicWindow.Awtomic?.subscriptionBillingAttempts;
        if (Array.isArray(billingAttempts)) {
          const now = new Date();
          const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
          for (let i = 0; i < billingAttempts.length; i++) {
            const attempt = billingAttempts[i];
            if (!attempt || attempt.BillingAttemptStatus !== "SUCCESS") continue;
            const billedAt = new Date(attempt.CompletedAt || attempt.CreatedAt);
            if (Number.isNaN(billedAt.getTime())) continue;
            if (now.getTime() - billedAt.getTime() <= THIRTY_DAYS_MS) {
              recentlyBilled = true;
              break;
            }
          }
        }

        // CX-4727 item 3 — even when in-window, KEEP cp-edit-hidden if the
        // subscription had a successful billing attempt in the last 30 days.
        if (
          !pickupBlocked && // PICKUP subs stay non-editable regardless of other gates
          (hasEditBlockException || // CX-4775 — exception products bypass release-window + recently-billed
            (!recentlyBilled && (!matchedReleaseWindowLineCount || matchedReleaseWindowLineCount === matchedReleaseWindowLineCountInsideWindow)))
        ) {
          document.body.classList.remove("cp-edit-hidden");
        }
      } catch (_e) {
        // silent fail
      }

      // Auto-click edit button if coming from subscription list with editingBundleId
      const editingBundleId = localStorage.getItem("editingBundleId");
      if (editingBundleId) {
        // Clear the flag immediately
        localStorage.removeItem("editingBundleId");

        // Wait for the table row with matching variant ID to appear, then click its edit button
        waitForElement(
          `.bundle-table__body-row.pv_${CSS.escape(editingBundleId)} .awtomatic-line-edit-button`,
          (elements) => {
            const btn = elements && elements[0];
            if (btn && typeof btn.click === "function") {
              btn.click();

              // After clicking edit button, also click the "edit my box" action item
              waitForElement(
                `.bundle-table__body-row.pv_${CSS.escape(editingBundleId)} .bundle-action-item--edit_my_box`,
                (editBoxElements) => {
                  const editBoxBtn = editBoxElements && editBoxElements[0];
                  if (editBoxBtn && typeof editBoxBtn.click === "function") {
                    editBoxBtn.click();
                  }
                },
                100,
                10000
              );
            }
          },
          100,
          10000
        );
      }

      // Wrap the Cancel + Pause buttons inside a "Membership options" accordion.
      // Awtomic re-renders the button area on edits, so this is idempotent and
      // re-runs from a MutationObserver: if the live Cancel button isn't already
      // inside our accordion, rebuild it (dropping any stale accordion).
      const buildMembershipAccordion = () => {
        // only build when Cancel exists; if it does, include the Pause button
        // too (even though it's hidden via CSS). So: cancel+pause, cancel, or nothing.
        const cancelBtn = document.querySelector("body.awt-cp .bundle-button--cancel");
        if (!cancelBtn) return; // no Cancel -> nothing to wrap
        if (cancelBtn.closest(".awt-membership-options")) return; // already wrapped
        // drop any stale accordion left over from a previous render
        document.querySelectorAll(".awt-membership-options").forEach((el) => el.remove());

        const pauseBtn = document.querySelector("body.awt-cp .bundle-button--pause");

        const acc = document.createElement("div");
        acc.className = "awt-membership-options";

        const header = document.createElement("button");
        header.type = "button";
        header.className = "awt-membership-options__header";
        header.setAttribute("aria-expanded", "false");
        header.innerHTML =
          '<span class="awt-membership-options__icon" aria-hidden="true"></span>' + '<span class="awt-membership-options__label">Membership options</span>';

        const panel = document.createElement("div");
        panel.className = "awt-membership-options__panel";
        const panelInner = document.createElement("div");
        panelInner.className = "awt-membership-options__panel-inner";
        panel.appendChild(panelInner);

        header.addEventListener("click", () => {
          const open = acc.classList.toggle("is-open");
          header.setAttribute("aria-expanded", open ? "true" : "false");
        });

        // place the accordion where the Cancel button was, then move the buttons
        // into the panel (moving preserves Awtomic's click handlers)
        cancelBtn.parentNode.insertBefore(acc, cancelBtn);
        acc.appendChild(header);
        acc.appendChild(panel);
        if (pauseBtn) panelInner.appendChild(pauseBtn);
        panelInner.appendChild(cancelBtn);
      };

      waitForElement(".bundle-button--cancel", buildMembershipAccordion, 100, 15000);
      const membershipAccObserver = new MutationObserver(buildMembershipAccordion);
      membershipAccObserver.observe(document.body, { childList: true, subtree: true });
    });

    // CX-4727 item 3a — treat a just-triggered order / just-finished edit as
    // blocked: re-add cp-edit-hidden immediately so the UI assumes editing is
    // off until awtomic-cp-loaded re-asserts the real window state. UI
    // deterrent only — there is no server-side order-now lockout.
    const cx4727Reblock = () => {
      document.body && document.body.classList.add("cp-edit-hidden");
    };
    window.addEventListener("awtomic-force-order-completed", cx4727Reblock);
    // window.addEventListener("awtomic-box-edit-modal-closed", cx4727Reblock);

    // CX-4727 item 4 — persistent confirmation banner after a forced order.
    // The built-in success toast closes instantly on HALL, so inject a
    // persistent .awt-info-style banner instead. Dismisses on navigation.
    window.addEventListener("awtomic-force-order-completed", () => {
      try {
        if (document.querySelector(".awt-order-confirmation-banner")) return; // idempotent
        const banner = document.createElement("div");
        banner.className = "awt-info awt-order-confirmation-banner";
        banner.innerHTML = '<p style="">Your order has been triggered successfully.</p>';
        waitForElement(
          ".bundle-details-table-title",
          (elements) => {
            if (document.querySelector(".awt-order-confirmation-banner")) return;
            const anchor = elements && elements[0];
            if (anchor && anchor.parentNode) {
              anchor.parentNode.insertBefore(banner, anchor);
            } else {
              document.body && document.body.appendChild(banner);
            }
          },
          100,
          10000
        );
      } catch (_e) {
        // silent fail — never break the CP
      }
    });

    // After a forced order completes on the subscription detail view, send the
    // customer to the subscription list (the same portal path without
    // ?subscriptionId=) with an order-placed flag so the confirmation banner
    // shows on the list. Only fires from a detail view, so it never affects
    // normal navigation.
    window.addEventListener("awtomic-force-order-completed", () => {
      try {
        if (!window.location.search.includes("subscriptionId=")) return;
        const url = new URL(window.location.href);
        url.searchParams.delete("subscriptionId");
        url.searchParams.set("awt-order-placed", "1");
        // small delay so the customer perceives the success state first
        setTimeout(() => {
          window.location.assign(url.pathname + url.search + url.hash);
        }, 1200);
      } catch (_e) {
        // silent fail — never break the CP
      }
    });

    //wait for .bundle-shipment-body and debugger
    waitForElement(
      ".bundle-shipment-body",
      (element) => {
        console.log(element);
        const infoDiv = document.createElement("div");
        infoDiv.className = "awt-info";

        // General disclaimer — shown to everyone, always first regardless of state.
        infoDiv.innerHTML = `<p style="">Ground shipping may be unavailable or significantly delayed due to extreme hot or cold temperatures.</p>`;

        //element is a node list check if includes " CA " if so add the CA-only disclaimers
        if (Array.from(element).some((el) => el.textContent && el.textContent.includes(" CA "))) {
          // CX-4727 item 2 — CRV above the two WARNING paragraphs (reordered).
          infoDiv.innerHTML += `<p style="">A California CRV fee of $0.05 per 375mL bottle and $0.10 per 750mL and 1.5L bottles will be applied to all CA orders.</p>
        <p style="">WARNING: Many food and beverage cans have linings containing bisphenol A (BPA), a chemical known to the State of California to cause harm to the female reproductive system. Jar lids and bottle caps may also contain BPA. You can be exposed to BPA when you consume foods or beverages packaged in these containers. For more information go to: <a href="http://www.p65warnings.ca.gov/bpa" target="_blank" rel="noopener noreferrer">www.p65warnings.ca.gov/bpa</a></p>
        <p style="">WARNING: Drinking distilled spirits, beer, coolers, wine and other alcoholic beverages may increase cancer risk, and, during pregnancy, can cause birth defects. For more information go to: <a href="http://www.p65warnings.ca.gov/alcohol" target="_blank" rel="noopener noreferrer">www.p65warnings.ca.gov/alcohol</a></p>`;
        }

        // track the last state we acted on, so multiple DOM mutations that land
        // on the same boundary only fire once per real transition
        const placeAfterTotals = () => {
          const totals = document.querySelector(".awt-confirmation-totals");
          if (!totals) return false;
          // insert the disclaimer info right after the totals as a sibling
          totals.parentNode.insertBefore(infoDiv, totals.nextSibling);
          return true;
        };
        let wasPresent = false;
        const observer = new MutationObserver(() => {
          const isPresent = !!document.querySelector(".awt-confirmation-totals");
          if (isPresent === wasPresent) return; // no real change since last time
          wasPresent = isPresent;
          if (isPresent) placeAfterTotals();
        });
        observer.observe(document.body, { childList: true, subtree: true });

        // handle the case where it is already present on load
        if (placeAfterTotals()) wasPresent = true;
      },
      100,
      10000
    );

    // CX-4726 item 10 — swap "Edit" -> "Customize" on the wine clubs.
    // CSS content: can't reliably replace a real text node across CP
    // re-renders, so do it in JS via waitForElement (re-fires on mutation).
    const cx4726SwapEditLabel = (elements) => {
      elements.forEach((el) => {
        // Replace only the exact "Edit" text, preserving any icon nodes.
        el.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent && node.textContent.trim() === "Edit") {
            node.textContent = node.textContent.replace("Edit", "Customize");
          }
        });
        // Fallback: if the button's whole label is "Edit" with no child icon.
        if (el.children.length === 0 && el.textContent && el.textContent.trim() === "Edit") {
          el.textContent = "Customize";
        }
      });
    };
    waitForElement(".awtomatic-line-edit-button", cx4726SwapEditLabel, 100, 15000);
  }

  // ===================================================================
  // CX-4726 — [HALL] General CP Edits (rev 3)
  // Per-brand membership copy for item 3. Keyed by body[data-brand]
  // value (hall | walt | baca | michelfoch). Each brand has one or more
  // membership tiers (title + paragraphs). Source: HALL CX attachment
  // custom-copy-under-subscription-ilst.txt.
  // ===================================================================
  /** @type {Record<string, { heading: string, tiers: { title: string, paragraphs: string[] }[] }>} */
  const cx4726MembershipCopy = {
    hall: {
      heading: "Membership Information",
      tiers: [
        {
          title: "The Collection",
          paragraphs: [
            "The Collection offers access to some of HALL's most limited and highly sought-after Cabernet Sauvignon releases. Many of our smallest production wines and single-vineyard bottlings are reserved exclusively for Collection Members.",
            "Typical club shipments include two of our newest releases, with the option to receive 2, 4, or 6 bottles per shipment. If you choose 6 bottle shipments you will enjoy $5 standard shipping on all club shipments.",
            "As our most elevated membership, The Collection offers deeper access to HALL's cellar along with enhanced benefits — including invitations to Collection Member–exclusive events, rare library releases, additional complimentary tastings, and more throughout the year."
          ]
        },
        {
          title: "Primary Colors",
          paragraphs: [
            "Primary Colors membership offers access to many of our most beloved wines, including Cabernet Sauvignon and other Bordeaux varietals available directly from the winery.",
            "Typical club shipments include two of our newest releases, with the option to receive 2, 4, or 6 bottles per shipment. If you choose 6 bottle shipments you will enjoy $5 standard shipping on all club shipments.",
            "Primary Colors is a great way to stay connected to HALL, with flexibility and exclusive member access throughout the year.",
            "Ready for more? Primary Colors members can upgrade to The Collection at any time to unlock our full suite of enhanced benefits and experiences."
          ]
        }
      ]
    },
    walt: {
      heading: "Membership Information",
      tiers: [
        {
          title: "Vintner's Club",
          paragraphs: [
            "Membership in the Vintner's Club grants you access to our most precious single vineyard wines sourced from premier Pacific Coast vineyards, each with its unique expression of the land. Winemaker, Megan Gunderson Paredes, selects two wines to be featured in each quarterly shipment. As a member, you may elect to receive one bottle of each wine (a two bottle shipment), or increase your guaranteed allocation by claiming two or three of each selection (a four or six bottle shipment respectively). The average price for a two bottle shipment is $135 + shipping and tax. Shipments of six bottles or more enjoy $5 standard shipping."
          ]
        },
        {
          title: "Appellation Membership",
          paragraphs: [
            "Our Appellation Membership grants priority access to all our WALT Collection wines after Vintner's Club access. Shipments include wines from the WALT Appellation and our Single Vineyard Portfolio. The average price per shipment is $100 + shipping and tax. Shipments of six bottles or more enjoy $5 standard shipping."
          ]
        }
      ]
    },
    baca: {
      heading: "Membership Information",
      tiers: [
        {
          title: "Be BACA.",
          paragraphs: [
            "Like you, we're seekers of adventure, spectacular wine, and unforgettable experiences. We bring a fresh approach to winemaking but our origin story includes some of California's best winemakers and vintners. Best of both worlds, we say.",
            "Our club is called THE LIST",
            "BACA is available in very limited quantities. But as a member of THE LIST you'll have first access to our releases. The average price per shipment is $100 + shipping and tax. Shipments of six bottles or more enjoy $5 standard shipping. Join now, joy later."
          ]
        }
      ]
    },
    michelfoch: {
      heading: "Membership Information",
      tiers: [
        {
          title: "Michel Foch Membership",
          paragraphs: [
            "Membership with Michel Foch offers French Champagne directly to your door four times per year. Receive access to our member-only wines and discounts across the entire portfolio including wines from Michel Foch, HALL, WALT, and BACA.",
            "Typically, each club shipment will include two of our latest releases. Choose to receive a total of 2, 4 or 6 bottles in each shipment. If you choose 6 bottle shipments, you will enjoy $5 standard shipping on all club shipments.",
            "Perfect for those looking for the ultimate in access and flexibility! We will always email you ahead of each shipment, notifying you of what exciting new releases are reserved for you. At that time, you are welcome to contact us and customize your shipment."
          ]
        }
      ]
    }
  };

  /** Signup + per-brand benefits page paths (built in CX-4671).
   * Signup is a single shared page (template page.club-signup.json); the
   * benefits page is per-brand (page.{hall|walt|baca|mf}-membership-benefits
   * .json all exist in this theme). Page HANDLES are assumed to match the
   * template stems — confirm in the open questions if HALL renamed any. */
  const CX4726_SIGNUP_PATH = "/pages/club-signup";
  /** @type {Record<string, { signup: string, benefits: string }>} */
  const cx4726BrandPages = {
    hall: { signup: CX4726_SIGNUP_PATH, benefits: "/pages/hall-membership-benefits" },
    walt: { signup: CX4726_SIGNUP_PATH, benefits: "/pages/walt-membership-benefits" },
    baca: { signup: CX4726_SIGNUP_PATH, benefits: "/pages/baca-membership-benefits" },
    michelfoch: { signup: CX4726_SIGNUP_PATH, benefits: "/pages/mf-membership-benefits" }
  };

  /** @returns {string} the current brand key from body[data-brand], or "hall" as a safe default */
  const cx4726GetBrand = () => {
    const b = document.body && document.body.getAttribute("data-brand");
    return b && cx4726MembershipCopy[b] ? b : "hall";
  };

  // When arriving on the subscription list right after a forced order
  // (order-placed flag present in the URL), render the confirmation banner on
  // the list, anchored to the list container.
  try {
    if (window.location.search.includes("awt-order-placed=1")) {
      const banner = document.createElement("div");
      banner.className = "awt-info awt-order-confirmation-banner";
      banner.innerHTML = '<p style="">Your order has been triggered successfully.</p>';
      waitForElement(
        ".bundleapp-subscription-list-item, .bundleapp-subscription-list, .bundle-subscriptions-list-container",
        (elements) => {
          if (document.querySelector(".awt-order-confirmation-banner")) return;
          const anchor = elements && elements[0];
          if (anchor && anchor.parentNode) {
            anchor.parentNode.insertBefore(banner, anchor);
          } else {
            document.body && document.body.appendChild(banner);
          }
        },
        100,
        10000
      );
    }
  } catch (_e) {
    // silent fail — never break the CP
  }

  //my subscruptions list page
  // CX-4726 rev 4 — the Awtomic CP renders client-side wherever the app
  // mounts; on HALL it is NOT served at the literal /tools/bundle-subscriptions
  // path, so the old exact-URL gate never matched and body.awt-my-subs was
  // never applied (Brian, comment 67762). Detect the list by DOM presence
  // instead, and exclude the detail view (?subscriptionId=) + the BaB flow so
  // the list-only logic doesn't fire there. Add awt-my-subs the moment the
  // subscription list appears (it can mount after first paint).
  const cx4726IsDetailView = window.location.search.includes("subscriptionId=");
  const cx4726IsBabFlow = window.location.pathname.includes("/tools/bundle-subscriptions/bundle/");
  if (!cx4726IsDetailView && !cx4726IsBabFlow) {
    // CX-4726 items 1, 1a, 2, 3 — render below the subscriptions list.
    // The list item itself is the reliable, app-rendered hook (works on any
    // page/handle the merchant mounts the CP under).
    waitForElement(
      ".bundleapp-subscription-list-item, .bundleapp-subscription-list, .bundle-subscriptions-list-container",
      () => {
        try {
          // Apply the body class here (not behind a URL gate) so the
          // body.awt-my-subs CSS (items 4/5) reliably scopes to the real list.
          document.body && document.body.classList.add("awt-my-subs");

          if (document.querySelector(".cx4726-cp-footer")) return; // idempotent

          const brand = cx4726GetBrand();
          const pages = cx4726BrandPages[brand];
          const copy = cx4726MembershipCopy[brand];

          // Determine whether the customer has any ACTIVE subscriptions.
          const listItems = document.querySelectorAll(".bundleapp-subscription-list-item");
          let hasActiveSub = false;
          listItems.forEach((item) => {
            const cancelled =
              item.querySelector(".bundleapp-subscription-list-item__subscription-not-active-status") ||
              item.classList.contains("bundleapp-subscription-list-item--cancelled");
            if (!cancelled) hasActiveSub = true;
          });

          const footer = document.createElement("div");
          footer.className = "cx4726-cp-footer";

          // Wrapper for buttons to display side by side.
          const buttonsContainer = document.createElement("div");
          buttonsContainer.className = "cx4726-buttons-container";

          // Item 1 / 1a — contextual Join / Add button.
          const joinBtn = document.createElement("a");
          joinBtn.className = "cx4726-membership-cta membership-btn";
          joinBtn.href = pages.signup;
          joinBtn.textContent = hasActiveSub ? "Add a wine club membership" : "Join a wine club membership";
          buttonsContainer.appendChild(joinBtn);

          // Item 2 — "Your membership benefits" button.
          const benefitsBtn = document.createElement("a");
          benefitsBtn.className = "cx4726-benefits-cta membership-btn";
          benefitsBtn.href = pages.benefits;
          benefitsBtn.textContent = "Your membership benefits";
          buttonsContainer.appendChild(benefitsBtn);

          footer.appendChild(buttonsContainer);

          // Item 3 — brand-contextual membership info block.
          if (copy) {
            const section = document.createElement("div");
            section.className = "membership-section cx4726-membership-info";

            const container = document.createElement("div");
            container.className = "membership-container";

            const title = document.createElement("h2");
            title.className = "membership-title";
            title.textContent = copy.heading;
            container.appendChild(title);

            copy.tiers.forEach((tier) => {
              const tierTitle = document.createElement("h3");
              tierTitle.className = "column-title";
              tierTitle.textContent = tier.title;
              container.appendChild(tierTitle);

              tier.paragraphs.forEach((p) => {
                const para = document.createElement("p");
                para.className = "membership-description";
                para.textContent = p;
                container.appendChild(para);
              });
            });

            section.appendChild(container);
            footer.appendChild(section);
          }

          // Place the footer at the bottom of the list. Prefer inserting
          // right after the actual list container so it reads as part of the
          // list; fall back to body so it always renders somewhere visible.
          const listContainer =
            document.querySelector(".bundleapp-subscription-list") ||
            document.querySelector(".bundle-subscriptions-list-container") ||
            (document.querySelector(".bundleapp-subscription-list-item") && document.querySelector(".bundleapp-subscription-list-item").parentElement);
          if (listContainer && listContainer.parentNode) {
            listContainer.parentNode.insertBefore(footer, listContainer.nextSibling);
          } else {
            document.body.appendChild(footer);
          }
        } catch (_e) {
          // silent fail — never break the list page
        }
      },
      100,
      10000
    );
  }

  //bab purchase  flow
  if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
    awtomicWindow.Awtomic = awtomicWindow.Awtomic || {};
    awtomicWindow.Awtomic.getBabSelection = () => {
      const babProductId = document
        .querySelector(".bundle-container")
        ?.className.split(" ")
        .find((c) => c.startsWith("pv_"))
        ?.split("_")[1];
      if (!babProductId) return { object: {}, queryString: "" };

      const bundleProductCards = document.querySelectorAll(".bundle-product-card");
      /** @type {Record<string, number>} */
      const bundleSelectedProducts = {};

      bundleProductCards.forEach((card) => {
        const productId = card.getAttribute("data-pid");
        const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
        const quantity = quantityElement ? parseInt(quantityElement.innerHTML, 10) : 0;
        if (productId && quantity > 0) {
          bundleSelectedProducts[productId] = quantity;
        }
      });

      const queryString = Object.entries(bundleSelectedProducts)
        .map(([id, quantity]) => `${id}=${quantity}`)
        .join("&");

      const currentUrl = window.location.href;
      const separator = currentUrl.includes("?") ? "&" : "?";
      const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

      return {
        object: { [babProductId]: bundleSelectedProducts },
        queryString,
        fullUrl
      };
    };

    const urlParts = window.location.pathname.split("/");
    const bundleId = urlParts[urlParts.length - 1];

    if (bundleId) {
      document.body && document.body.classList.add(`awt-bundle-${bundleId}`);
    }
  }

  //"My Clubs" / my subs
  if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
    // Copy subscription action buttons to first child divs
    waitForElement(".bundleapp-subscription-list-item", () => {
      document.querySelectorAll(".bundleapp-subscription-list-item button.bundle-button.button--primary").forEach((button) => {
        const listItem = button.closest(".bundleapp-subscription-list-item");
        if (listItem) {
          const subscriptionId = listItem.getAttribute("data-subscription-id");
          const firstChildDiv = listItem.querySelector(":scope > div:first-child");
          if (firstChildDiv && subscriptionId) {
            // Find subscription data
            const subscription = window.Awtomic?.subscriptionList?.find((sub) => sub.SubscriptionId?.endsWith(subscriptionId));
            if (!subscription) return;

            // Check if this subscription has a bundle line (has _bundleUid)
            const hasBundle = subscription.Lines?.some((line) => line.CustomAttributes?.some((attr) => attr.key === "_bundleUid"));
            if (!hasBundle) return; // Skip if not a bundle subscription

            // Get the _variantId from the first bundle Line
            const bundleLine = subscription.Lines?.find((line) => line.CustomAttributes?.some((attr) => attr.key === "_bundleUid"));
            const variantId = bundleLine?.CustomAttributes?.find((attr) => attr.key === "_variantId")?.value;
            if (!variantId) return;

            // Check if editing is allowed based on release window and billing history
            let isEditingAllowed = true;
            let hasEditBlockException = false;

            // Check for exception products (CX-4775)
            // For bundles, use the _bundleProductId from CustomAttributes, not the line's ProductId
            if (subscription.Lines) {
              for (const line of subscription.Lines) {
                const bundleProductId = line.CustomAttributes?.find((attr) => attr.key === "_bundleProductId")?.value;
                const productIdToCheck = bundleProductId || line.ProductId;

                if (productIdToCheck && isEditBlockExceptionProductId(productIdToCheck)) {
                  hasEditBlockException = true;
                  break;
                }
              }
            }

            if (!hasEditBlockException) {
              // Check release window
              let matchedReleaseWindowLineCount = 0;
              let matchedReleaseWindowLineCountInsideWindow = 0;

              // customization-window gating (skipped when useCustomizationWindow is false)
              if (useCustomizationWindow && subscription.Lines) {
                for (const line of subscription.Lines) {
                  // For bundles, use the _bundleProductId from CustomAttributes
                  const bundleProductId = line.CustomAttributes?.find((attr) => attr.key === "_bundleProductId")?.value;
                  const productId = bundleProductId || line.ProductId;

                  if (!productId) continue;

                  const data = getReleaseWindowFromProductId(productId);
                  if (data) {
                    matchedReleaseWindowLineCount += 1;
                    const now = new Date();
                    const currentYear = now.getFullYear();
                    const customizationStarts = parseMonthDayStart(data.Shipping.date.customizationStarts, currentYear);
                    const customizationEnds = parseMonthDayEnd(data.Shipping.date.customizationEnds, currentYear);

                    if (customizationEnds < customizationStarts) {
                      customizationEnds.setFullYear(customizationEnds.getFullYear() + 1);
                    }

                    if (now >= customizationStarts && now <= customizationEnds) {
                      matchedReleaseWindowLineCountInsideWindow += 1;
                    }
                  }
                }
              }

              // Check if billed in the last 30 days
              let recentlyBilled = false;
              if (subscription.Lines && subscription.Lines.length > 0) {
                const now = new Date();
                const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

                for (const line of subscription.Lines) {
                  if (line.SuccessfulBillingAttempts && Array.isArray(line.SuccessfulBillingAttempts)) {
                    if (line.SuccessfulBillingAttempts.length > 0) {
                      const nextBillingDate = subscription.NextBillingDate ? new Date(subscription.NextBillingDate) : null;
                      if (nextBillingDate) {
                        // Calculate approximate last billing date (3 months ago based on frequency)
                        const approxLastBilling = new Date(nextBillingDate.getTime() - 90 * 24 * 60 * 60 * 1000);
                        if (now.getTime() - approxLastBilling.getTime() <= THIRTY_DAYS_MS) {
                          recentlyBilled = true;
                          break;
                        }
                      }
                    }
                  }
                }
              }

              // Determine if editing is blocked
              if (matchedReleaseWindowLineCount > 0 && matchedReleaseWindowLineCount !== matchedReleaseWindowLineCountInsideWindow) {
                isEditingAllowed = false; // Outside release window
              }
              if (recentlyBilled) {
                isEditingAllowed = false; // Recently billed
              }
            }

            // PICKUP subscriptions are non-editable when disablePickupEdit is on.
            if (disablePickupEdit && isPickupSubscription(subscription)) {
              isEditingAllowed = false;
            }

            // Only create and render button if editing is allowed
            if (!isEditingAllowed) return;

            // Create new button without event listeners
            const clonedButton = document.createElement("button");
            clonedButton.className = button.className;
            clonedButton.innerHTML = "Customize";
            clonedButton.style.backgroundColor = "var(--primary-btn-color)";
            clonedButton.style.color = "var(--primary-btn-bg-color)";
            clonedButton.style.fontSize = "12px";
            clonedButton.style.padding = "0 11px";
            clonedButton.style.minWidth = "auto";

            // Add click event to save bundle VariantId and click Manage button
            clonedButton.addEventListener("click", () => {
              localStorage.setItem("editingBundleId", variantId);
              button.click();
            });

            clonedButton.setAttribute("data-bundle-variant-id", variantId);
            clonedButton.setAttribute("data-subscription-id", subscriptionId);

            const wrapper = document.createElement("div");
            wrapper.style.borderBottom = "var(--r1c2BorderBottom)";
            wrapper.appendChild(clonedButton);

            // Insert at 3rd position (index 2)
            const thirdChild = firstChildDiv.children[2];
            if (thirdChild) {
              firstChildDiv.insertBefore(wrapper, thirdChild);
            } else {
              firstChildDiv.appendChild(wrapper);
            }
          }
        }
      });
    });
  }
})();
